import { customColumn, dateColumn, StatusPill, textColumn } from '@portals-platform/ui';
import type { ColumnDef } from '@tanstack/react-table';
import type { CertificateRow } from '../../data-access/index.js';
import { describeCertStatus, isReferred } from '../../lib/cert-status.js';
import { CertificateActions, ReferralInfoButton } from './certificate-row-actions.js';

export const certificateColumns = [
  textColumn<CertificateRow>((row) => row.countryName, {
    id: 'countryName',
    header: 'Country',
    enableSorting: false,
  }),
  textColumn<CertificateRow>((row) => row.certificateIssuedTo, {
    id: 'certificateIssuedTo',
    header: 'Customer Name',
    enableSorting: false,
  }),
  textColumn<CertificateRow>((row) => row.createdBy, {
    id: 'createdBy',
    header: 'Created By',
    enableSorting: false,
  }),
  dateColumn<CertificateRow>((row) => row.createdAt, {
    id: 'createdAt',
    header: 'Created On',
  }),
  customColumn<CertificateRow>(
    (row) => {
      const { label, tone } = describeCertStatus(row.currentStatus);
      return (
        <div className="flex items-center gap-0.5">
          <StatusPill tone={tone}>{label}</StatusPill>
          {isReferred(row.currentStatus) && <ReferralInfoButton certificate={row} />}
        </div>
      );
    },
    { id: 'currentStatus', header: 'Status' },
  ),
  customColumn<CertificateRow>((row) => <CertificateActions certificate={row} />, {
    id: 'actions',
    header: 'Actions',
    enableHiding: false,
  }),
] as ColumnDef<CertificateRow, never>[];
